"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _dist = require("kubra-ux/dist");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _NumberFormatter = _interopRequireDefault(require("../modules/NumberFormatter"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // eslint-disable-next-line


var ReportHeader = function ReportHeader(_ref) {
  var deviceType = _ref.deviceType,
      custA = _ref.custA,
      custS = _ref.custS,
      setFilterTerm = _ref.setFilterTerm;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "report-header device-".concat(deviceType)
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'filter-box-container'
  }, /*#__PURE__*/_react.default.createElement(_dist.InputField, {
    id: 'filter-box',
    placeholder: 'Enter Area to Filter',
    icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'search']
    }),
    onChangeValue: function onChangeValue(value) {
      return setFilterTerm(value);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'report-info-box',
    style: {
      backgroundColor: '#0B5AA2'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'icon'
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'exclamation-triangle'],
    color: 'white'
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: 'label'
  }, "Total Customers Affected"), /*#__PURE__*/_react.default.createElement("span", {
    className: 'value'
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, custA))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'report-info-box',
    style: {
      backgroundColor: '#0B5AA2'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'icon'
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'user'],
    color: 'white'
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: 'label'
  }, "Total Customers Served"), /*#__PURE__*/_react.default.createElement("span", {
    className: 'value'
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, custS))));
};

ReportHeader.propTypes = {
  custA: _propTypes.default.number.isRequired,
  custS: _propTypes.default.number.isRequired,
  deviceType: _propTypes.default.string.isRequired,
  setFilterTerm: _propTypes.default.func.isRequired
};
var _default = ReportHeader;
exports.default = _default;